import React from "react";
import "./Section.css";

class Section extends React.Component{
    render(){
        return (
            <div className="Section">
                <div>
                <div className="section-title">{this.props.title}</div>
                <hr style={{color: "dimgray", borderColor: "dimgray", backgroundColor: "dimgray"}}></hr>
                <div className="section-text"> {this.props.text}</div>
                </div>
            </div>
        )
    }
}

export default Section;